import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs';
import { SortDirection } from '../../../../../interfaces/schema';
import { AuthActions } from '../../../../components/auth/auth.actions';
import { HomeMyHealthPassportHealthRecordActions } from './health-record.actions';
import { HomeMyHealthPassportHealthRecordService } from './health-record.service';

/**
 * @description HomeMyHealthPassportHealthRecord Effects.
 * @exports
 * @class HomeMyHealthPassportHealthRecordEffects
 */
@Injectable()
export class HomeMyHealthPassportHealthRecordEffects extends HomeMyHealthPassportHealthRecordService {
  private readonly actions = inject(Actions);

  readonly onAuthLogin_Activation_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(
          AuthActions.login,
          AuthActions.activation,
          AuthActions.switchProfile
        ),
        map(() => HomeMyHealthPassportHealthRecordActions.reset()),
        map(() => HomeMyHealthPassportHealthRecordActions.fetch())
      );
    },
    { dispatch: true }
  );

  readonly onAuthLogout = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout),
        map(() => HomeMyHealthPassportHealthRecordActions.reset())
      );
    },
    { dispatch: true }
  );

  readonly onFetch = createEffect(
    () => {
      return this.actions.pipe(
        ofType(HomeMyHealthPassportHealthRecordActions.fetch),
        concatMap(() =>
          this.findAllEHRMCUAndEHRLab({
            limit: 3,
            offset: 0,
            sort: {
              createdAt: SortDirection.Desc
            },
            count: false
          })
        ),
        map(({ results = [] }) =>
          HomeMyHealthPassportHealthRecordActions.setData({ data: results })
        )
      );
    },
    { dispatch: true }
  );
}
